import React from 'react';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Grid, IconButton } from '@mui/material';
import { PaginationOrder } from '@/common/types';
import { PractitionersListHeaderWrapper } from './styles';

interface Props {
    order?: PaginationOrder;
    onToggleOrder?: () => void;
}

export const PractitionersListHeader = ({ order, onToggleOrder }: Props) => {
    return (
        <PractitionersListHeaderWrapper container spacing={2}>
            <Grid item xs={3} lg={3} xl={3}>
                <strong>Name</strong>
                {onToggleOrder && (
                    <IconButton
                        size="small"
                        onClick={onToggleOrder}
                        aria-label={`Sort by last name ${order === 'ASC' ? 'descending' : 'ascending'}`}
                    >
                        {order === 'ASC' ? (
                            <ArrowUpwardIcon fontSize="small" />
                        ) : (
                            <ArrowDownwardIcon fontSize="small" />
                        )}
                    </IconButton>
                )}
            </Grid>
            <Grid item xs={3} lg={4} xl={4}>
                <strong>Email</strong>
            </Grid>
            <Grid item xs={2} lg={1.5}>
                <strong>Role</strong>
            </Grid>
            <Grid item xs={2} lg={3}>
                <strong>Locations</strong>
            </Grid>
        </PractitionersListHeaderWrapper>
    );
};
